module.exports = __webpack_public_path__ + "img/chr_ts_90_21_5.ee428191.png";